import apiHandler from "../core/apiHandler";

/**
 * 👁️ QZ Tray Preview API
 *
 * API base para generar y obtener la vista previa del ticket
 * antes de ser impreso localmente.
 *
 * ✅ Endpoints:
 * - GET  /api/qztray/preview/sample → Genera un ticket de ejemplo (logo, texto y QR)
 * - POST /api/qztray/preview        → Genera una vista previa real desde datos enviados
 */
const qzTrayPreviewApi = apiHandler("qztray/preview");

export default qzTrayPreviewApi;
